// accordion js
var acc = document.getElementsByClassName("cst-accordion");
var accWrapper = document.getElementsByClassName("accordion-wrapper");

var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    // Check if the parent or container has the class 'single-tab'
    var isSingleTab = this.closest(".accordion-wrapper").classList.contains("single-tab");

    // If the class 'single-tab' exists, close all other open panels first
    if (isSingleTab) {
      for (var j = 0; j < acc.length; j++) {
        var panel = acc[j].nextElementSibling;
        var wrapper = acc[j].closest(".accordion-wrapper");

        // Remove active class from other accordions and panels if they are not the clicked one
        if (acc[j] !== this) {
          acc[j].classList.remove("cst-active");
          wrapper.classList.remove("cst-active");
          panel.style.maxHeight = null;
        }
      }
    }

    // Toggle active class on the clicked accordion header
    this.classList.toggle("cst-active");

    // Toggle active class on the wrapper
    var wrapper = this.closest(".accordion-wrapper");
    wrapper.classList.toggle("cst-active");

    // Toggle the panel's maxHeight for the clicked accordion
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 15 + "px";
    }
  });
}